import { RemoteTagManager } from "divine-binary-tags";
export const ColumnTags = new RemoteTagManager("column-tags");
